import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';

import { Icon } from 'bv-components';
import { reset } from '../floating_navigation/helpers';

import * as componentTypes from './component_types';

const { store } = window.reduxState;

const nextIsTwin = (components, index) => (
  components.length > index + 1
    && componentTypes[components[index].type] === componentTypes[components[index + 1].type]
);

const LeftComponentsView = ({ components, loading }) => (loading ? null : (
  <div className="left-sidebar">
    <div className="left-components__back" onClick={reset}>
      <Icon className="left-components__back-icon" />
    </div>

    <Provider store={store}>
      <div className="left-components has-scroll-bars" id="left-components">
        {components.map((component, index) => {
          const Component = componentTypes[component.type];

          return Component
            ? <Component {...component.settings} nextIsTwin={nextIsTwin(components, index)} />
            : null;
        })}
      </div>
    </Provider>
  </div>
));

LeftComponentsView.propTypes = {
  components: PropTypes.instanceOf(Array).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default LeftComponentsView;
